// src/services/vraboteniService.js
import api from "@/api";

function toBit(v) {
  return v ? 1 : 0;
}

// нормализација на ред
function normalizeRow(r = {}) {
  const akt = r.aktiven ?? r.Aktiven ?? r.aktiven === 1 ?? r.Aktiven === 1;

  return {
    SifraID: r.SifraID ?? r.sifraID ?? r.id ?? null,
    Naziv: r.Naziv ?? r.naziv ?? r.ime ?? "",
    email: r.email ?? r.Email ?? "",
    Tel: r.Tel ?? r.tel ?? r.Telefon ?? r.telefon ?? "",
    Adresa: r.Adresa ?? r.adresa ?? "",
    aktiven: akt === 1 || akt === true,
    UserName: r.UserName ?? r.Username ?? r.userName ?? "",
    Password: r.Password ?? r.password ?? "",
  };
}

// payload 1:1 како DB
function toApiPayload(form) {
  return {
    SifraID: Number(form.SifraID),
    Naziv: form.Naziv || "",
    email: form.email || "",
    Tel: form.Tel || "",
    Adresa: form.Adresa || "",
    aktiven: toBit(!!form.aktiven),
    UserName: form.UserName || "",
    Password: form.Password || "",
  };
}

export async function apiGetVraboteni() {
  const res = await api.get("/vraboteni/get");
  const arr = Array.isArray(res.data) ? res.data : res.data?.data || [];
  return arr.map(normalizeRow);
}

export async function apiAddVraboten(form) {
  const payload = toApiPayload(form);
  const res = await api.post("/vraboteni/add", payload);
  return res.data;
}

/**
 * Update мора да е PUT (не POST) → инаку дава 405 Method Not Allowed
 */
export async function apiUpdateVraboten(form) {
  const payload = toApiPayload(form);
  const res = await api.put("/vraboteni/update", payload);
  return res.data;
}

export async function apiDeleteVraboten(SifraID) {
  const res = await api.delete(`/vraboteni/delete-vraboten/${SifraID}`);
  return res.data;
}

// helper: најди следна шифра (max + 1)
export function nextSifraID(list = []) {
  if (!Array.isArray(list) || list.length === 0) return 1;
  const nums = list
    .map((x) => Number(x.SifraID))
    .filter((n) => Number.isFinite(n));
  return nums.length ? Math.max(...nums) + 1 : 1;
}